import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import logo from "@/project/karuna/assets/ki-logo.png";
import navigationRoutes, {
  useKarunaLink,
} from "@/project/karuna/utils/navigationRoutes";

const PublicFooter = () => {
  const getLink = useKarunaLink();
  return (
    <footer className="border-t border-border bg-muted/30">
      <div className="container mx-auto px-4 py-12">
        <div className="grid gap-8 md:grid-cols-4">
          {/* About Column */}
          <div>
            <div className="mb-4">
              <img
                src={logo}
                alt="Karuna International"
                className="h-10 w-auto"
              />
            </div>
            <p className="text-sm text-muted-foreground">
              Building compassionate global citizens through value-based
              education and community engagement.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="mb-4 font-semibold">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to={getLink(navigationRoutes.HOME)}
                  className="text-muted-foreground transition-colors hover:text-primary"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to={getLink(navigationRoutes.ABOUT)}
                  className="text-muted-foreground transition-colors hover:text-primary"
                >
                  About Us
                </Link>
              </li>

              <li>
                <Link
                  to={getLink(navigationRoutes.CONTACT)}
                  className="text-muted-foreground transition-colors hover:text-primary"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="mb-4 font-semibold">Contact Us</h3>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li className="flex items-center space-x-2">
                <Mail className="h-4 w-4 text-primary" />
                <a
                  href="mailto:info@karunainternational.org"
                  className="transition-colors hover:text-primary"
                >
                  info@karunainternational.org
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="h-4 w-4 text-primary" />
                <a
                  href="tel:+917449493838"
                  className="transition-colors hover:text-primary"
                >
                  +91 74 4949 3838
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="mt-0.5 h-4 w-4 text-primary" />
                <span>Chennai, India.</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 border-t border-border pt-8">
          <div className="flex flex-col items-center justify-between space-y-4 md:flex-row md:space-y-0">
            <p className="text-sm text-muted-foreground">
              © {new Date().getFullYear()} Karuna International. All rights
              reserved.
            </p>
            <div className="flex items-center space-x-6 text-sm text-muted-foreground">
              <Link
                to={getLink(navigationRoutes.DEMO_LOGIN)}
                className="transition-colors hover:text-primary"
              >
                School Portal
              </Link>
              <Link
                to={getLink(navigationRoutes.DEMO_LOGIN)}
                className="transition-colors hover:text-primary"
              >
                Admin Portal
              </Link>
            </div>
          </div>
          <p className="mt-6 text-center text-sm text-muted-foreground">
            Designed and developed by{" "}
            <a
              href="https://www.universal-software.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-primary transition-colors hover:underline"
            >
              Universal Software
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
